module.exports = __webpack_public_path__ + "img/T5-A-xh_7.bbbe6742.png";